// extracted by mini-css-extract-plugin
module.exports = {"AppContainer":"App_AppContainer__381b2"};